<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['hhemp.question.title']">
              <a-input v-model="queryParam.title" :placeholder="language['ad.must.name']"></a-input>
            </a-form-item>
          </a-col>
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="是否第三方内容">-->
<!--              <j-dict-select-tag placeholder="请选择是否第三方内容" v-model="queryParam.isThird" dictCode="hhemp_isthird"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="8">
            <a-form-item :label="language['platform.roleUser.columns2.status']">
              <a-select default-value="-1" style="width: 240px"  v-model="queryParam.status" allowClear>
                <a-select-option value="1">
                  {{language['web.processed']}}
                </a-select-option>
                <a-select-option value="0">
                  {{ language['web.untreated'] }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
              <a-button type="primary" icon="download" style="margin-left: 8px" @click="handleExportXls(language['ese.feedback'])">{{language['common.exportButton']}}</a-button>
              </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->


    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
            <img v-else :src="getImgViewCode(text,applicationCode)" @click="imgView(getImgViewCode(text,applicationCode))" height="25px" width="50px" alt="" style="max-width:80px;max-height:160px;font-size: 12px;font-style: italic;cursor: pointer;"/>
          </div>
          <a-modal
            :mask="false"
            :width="1000"
            title="图片"
            :visible="previewVisible"
            :confirm-loading="false"
            :ok-button-props="{ props: { disabled: true } }"
            @cancel="handleCancel"
            :cancelText="language['common.closeButton']">
            <img alt="example" style="width: 100%;" :src="previewImage" />
          </a-modal>
        </template>

        <span slot="creater" slot-scope="text,record">
          <span >
            <p>{{record.userRealName}}</p>
            <p >({{record.userWorkNo}}) </p>
          </span>
        </span>
        <span slot="processeder" slot-scope="text,record">
          <span v-if="record.status=='1'">
            <p>{{record.processedName}}</p>
            <p >({{record.processedWorkNo}}) </p>
          </span>
        </span>
        <span slot="score" slot-scope="text,record">
          <span v-if="record.scoreStatus=='1'">
            <p><a-rate :default-value="record.score" disabled />  </p>
            <p ><a @click="handleEdit(record,'detailSource')" >{{language['hhemp.click.view']}} > </a></p>
          </span>
            <span v-else>
            <p>{{language['hhemp.feedback.Unrated']}}</p>
          </span>
        </span>
        <span slot="action" slot-scope="text, record" v-if="!onlyView">
<!--          <a @click="handleContent(record)">查看</a>-->
            <a @click="handleEdit(record,'detail')" >{{language['ispforum.details']}}</a>
             <span v-if="record.status=='0'">
              <a-divider type="vertical" />
              <a @click="handleEdit(record,'processed')">{{language['portal.ui2.toHandle']}}</a>
               </span>
              <a-divider type="vertical" />
        </span>


      </a-table>
    </div>

    <cms-banner-modal ref="modalForm" @ok="modalFormOk" :colid="this.colid"></cms-banner-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import CmsBannerModal from './modules/FreeBackModal'
  import { httpAction,getAction } from '@/api/manage'
  import { filterObj } from '@/utils/util';
  import { filterDictText } from '@/components/dict/JDictSelectUtil'
  import {  getDictItemsFromCache } from '@/api/api'
  export default {
    name: 'FreeBackList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      CmsBannerModal,
    },
    props: {
      colid: String,
      onlyView: {
        type: Boolean,
        default: false
      }
    },
    data () {
      const { language } = this.$store.getters;
      return language&&{
        isDisable:false,
        description: 'FreeBackList管理页面',
        feedbackTypeList:[],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:language['fd.emplostfound.lfno'],
            align:"center",
            dataIndex: 'feedbackCode',
            width: 150
          },
          {
            title: language['hhemp.question.type'],
            align: "center",
            dataIndex: 'feedbackType',
            ellipsis: true,
            customRender: (text) => {
              return filterDictText(this.feedbackTypeList, text)
            }
          },
          {
            title:language['hhemp.question.title'],
            align:"center",
            dataIndex: 'title',
            width: 150
          },
          {
            title:language['ipsys.createBy'],
            align:"center",
            dataIndex: 'entrance',
            scopedSlots: {customRender: "creater"},
          },
          {
            title:language['ipsys.createTime'],
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title:language['platform.roleUser.columns2.status'],
            align:"center",
            dataIndex: 'status',
            customRender:function (status) {
              if(status=='1'){
                return language['web.processed'];
              }else{
                 return language['web.untreated'];
              }
            }
          },
          {
            title:language['sweep_handleName'],
            align:"center",
            scopedSlots: {customRender: "processeder"},
          },
          {
            title:language['sweep_handleDate'],
            align:"center",
            dataIndex: 'processedTime'
          },
          {
            title:language['hhemp.rated'],
            align:"center",
            scopedSlots: {customRender: "score"},
          },
          {
            title: language['common.action'],
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:250,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/hhemp/feedback/feedbacks",
          delete: "/hhemp/feedback/feedbacks",
          deleteBatch: "/hhemp/feedback/feedbacks/batch",
          publish: "/hhemp/banner/publishstatus",
          publishBatch: "/hhemp/banner/publishstatus/batch",
          exportXlsUrl: "/hhemp/feedback/export-xls",
        },
        dictOptions:{},
        superFieldList:[],
        cols:[{
          id:'',
          colName:''
        }],
        applicationCode:'hhemp',
        previewVisible: false,
        previewImage: '',
        disableMixinCreated: false,
      }
    },
    created() {

      this.feedbackTypeList = getDictItemsFromCache('emp_freeback_type')

      //如果只是查看权限，就不显示后面操作按钮
      if(this.onlyView){
        this.columns=this.columns.slice(0, this.columns.length - 1)
      }

    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      handleEdit: function (record,type) {
        if(type=='processed'){
          this.$refs.modalForm.disableSubmit = false;
        }else{
          this.$refs.modalForm.disableSubmit = true;
        }
        record.flag = type;
        this.$refs.modalForm.title = this.language['hhemp.problem.feedback.details'];
        this.$refs.modalForm.edit(record);
      },
      getQueryParams() {
        // 路由参数
        if(this.colid!=null) {
          this.queryParam.colId = this.colid;
          this.isDisable=true;
        }
        if(this.$route.query.colid != undefined){
          this.queryParam.colId = this.$route.query.colid;
          this.$route.query.colid = null;
        }
        //获取查询条件
        let sqp = {}
        if(this.superQueryParams){
          sqp['superQueryParams']=encodeURI(this.superQueryParams)
          sqp['superQueryMatchType'] = this.superQueryMatchType
        }
        var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        return filterObj(param);
      },

      publish: function(record){
        var that = this;
        //上架
        this.$confirm({
          title:this.language['emp.col.status.publish'],
          content:this.language['emp.col.status.sureUpShelf'],
          onOk: function(){
            getAction(that.url.publish,{id:record.id,status:'1'}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      unpublish: function(record){
        var that = this;
        //上架
        this.$confirm({
          title:this.language['ad.offline'],
          content:this.language['emp.apptype.sureDownShelf'],
          onOk: function(){
            getAction(that.url.publish,{id:record.id,status:'0'}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      imgView(text){
        this.previewImage = text;
        this.previewVisible = true;
      },
      // 关闭模态框
      handleCancel() {
        this.previewVisible = false;
      },
      handleContent(record){
        this.$refs.ShowContent.detail(record,'ShowContent');
      },
    }
    ,mounted() {
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
